import React, {useState} from 'react';
import Heading from 'js/components/Common/Heading/Heading';
import useFetchData from 'js/hooks/useFetchData/useFetchData';
import Container from 'js/components/Common/Container/Container';
import ContactForm from 'js/components/Common/ContactForm/ContactForm';

import fetchData from './fetchData';
import classes from './ServicesForm.module.pcss';


interface Props {
    pageId: number
}

const ServicesForm = ({pageId}: Props) => {
    const [title, setTitle] = useState<string>('');

    useFetchData({
        query: `${fetchData(pageId)}`,
        condition: !!pageId,
        updateData: data => setTitle(data?.page?.ServicesTemplate?.titleServicesContact)
    });

    return (
        <section className={classes.ServicesForm}>
            <Container additionalClass={classes.Wrap}>
                <Heading text={title} />
                <ContactForm type={'servicesForm'}/>
            </Container>
        </section>
    );
};

export default ServicesForm;
